import { useTranslation } from 'react-i18next';
import type { JournalView } from '../../utils/journalViews';
import { Icon, List, Map as MapIcon } from '../ui/Icon';

const VIEWS = [
  { view: 'list', icon: List },
  { view: 'map', icon: MapIcon },
] as const;

interface Props {
  value: JournalView;
  onChange: (view: JournalView) => void;
}

/** The diary as a list of days or on the map. The album has its own tab (ADR-0046). */
export default function JournalViewToggle({ value, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center bg-slate-100 dark:bg-slate-800 rounded-xl p-0.5" role="tablist">
      {VIEWS.map(({ view, icon }) => (
        <button
          key={view}
          role="tab"
          aria-selected={value === view}
          onClick={() => onChange(view)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer ${
            value === view ? 'bg-white shadow-sm text-slate-900 dark:bg-slate-700 dark:text-slate-100' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
          }`}
        >
          <Icon as={icon} size={14} />
          {t(`journal.views.${view}`)}
        </button>
      ))}
    </div>
  );
}
